/**
 * HorseListToolbar — barre de « Mes Chevaux » : tri (S2) et chevaux archivés (S3)
 *
 * <select> natif plutôt qu'un menu maison : clavier, lecteurs d'écran et
 * sélecteur système des smartphones sont gérés par le navigateur.
 * L'interrupteur des archivés n'apparaît que s'il y a au moins un archivé.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTheme, TYPE, RADIUS } from '../constants/theme';
import { HORSE_LIST_SORT_MODES } from './horseListSort';

const SELECT_ID = 'horse-list-sort';

const HorseListToolbar = ({
  showSort, mode, onChange, saveError, archivedCount, showArchived, onToggleArchived, darkMode,
}) => {
  const { t: tr } = useTranslation();
  const t = getTheme(darkMode);
  if (!showSort && archivedCount === 0) return null;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '8px 16px', marginBottom: '16px' }}>
      {archivedCount > 0 ? (
        <label style={{ ...TYPE.label, color: t.textSecondary, display: 'inline-flex', alignItems: 'center', gap: '8px', minHeight: '44px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            role="switch"
            checked={showArchived}
            onChange={(e) => onToggleArchived(e.target.checked)}
            style={{ width: '18px', height: '18px', margin: 0, accentColor: t.accent, cursor: 'pointer' }}
          />
          {tr('horses.list.showArchived', { count: archivedCount })}
        </label>
      ) : <span />}

      {showSort && (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end', gap: '8px', flex: '1 1 260px' }}>
          <label htmlFor={SELECT_ID} style={{ ...TYPE.label, color: t.textSecondary }}>
            {tr('horses.list.sort.label')}
          </label>
          <select
            id={SELECT_ID}
            value={mode}
            onChange={(e) => onChange(e.target.value)}
            style={{
              ...TYPE.body,
              minHeight: '44px',
              minWidth: 0,
              flex: '0 1 280px',
              padding: '0 12px',
              borderRadius: RADIUS.md,
              border: `1px solid ${t.inputBorder}`,
              background: t.inputBg,
              color: t.textPrimary,
              cursor: 'pointer',
            }}
          >
            {HORSE_LIST_SORT_MODES.map((m) => (
              <option key={m} value={m}>{tr(`horses.list.sort.${m}`)}</option>
            ))}
          </select>
          {saveError && (
            <p role="status" style={{ ...TYPE.small, color: t.textSecondary, margin: 0, flexBasis: '100%', textAlign: 'right' }}>
              {tr('horses.list.sort.saveError')}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default HorseListToolbar;
